// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpService } from './../../core/services/http.service';
import { LoadingRoleDetailsAction, OrgLoadingRoleDetailsAction, SelectRoleAction } from './role-details.actions';
import { Injectable } from '@angular/core';
import { State } from '@app/memberonboarding/state';
import {
  QueueAlertAction,
  AlertType,
  GoAction,
  RoleGroup,
  RoleDetail,
  needsLoading,
  Loaded,
  MaybeLoadable,
  Role
} from '@app/core';
import { Store, select } from '@ngrx/store';
import { SelectGroupAction } from './group-details/group-details.actions';
import { selectRoleDetail } from '.';
import { take, filter, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RoleDetailsFacadeService {
  roleDetailsData$: any;
  role$: any;
  rolePolicies$: any;

  constructor(private store: Store<State>, private httpService: HttpService) {}

  initialize(roleId: string) {
    this.roleDetailsData$ = this.store.pipe(select(selectRoleDetail(roleId)));

    this.roleDetailsData$
      .pipe(
        filter((data: any) => !data || !data.role || !data.policies),
        take(1)
      )
      .subscribe(() => this.store.dispatch(new LoadingRoleDetailsAction(roleId)));

    this.role$ = this.roleDetailsData$.pipe(
      filter(data => !!data),
      map((data: RoleDetail) => data.role)
    );

    this.rolePolicies$ = this.roleDetailsData$.pipe(
      filter(data => !!data),
      map((data: RoleDetail) => data.policies)
    );
  }

  initializeOrgRoles(orgId: string, roleId: string) {
    this.roleDetailsData$ = this.store.pipe(select(selectRoleDetail(roleId)));

    this.roleDetailsData$
      .pipe(
        filter((data: any) => !data || !data.role),
        take(1)
      )
      .subscribe(() => this.store.dispatch(new OrgLoadingRoleDetailsAction({ orgId, roleId })));

    this.role$ = this.roleDetailsData$.pipe(
      filter(data => !!data),
      map((data: RoleDetail) => data.role)
    );
  }

  getRoleGroups(roleId: string) {
    return this.httpService.get(this.httpService.urls.roles.roleGroups, { urlParam: roleId });
  }

  refreshRole(roleId: string) {
    this.store.dispatch(new LoadingRoleDetailsAction(roleId));
  }

  removeRolePolicySuccess(roleId: string) {
    this.refreshRole(roleId);
    this.store.dispatch(new QueueAlertAction({ alertText: `Policy delete succeed.`, alertType: AlertType.SUCCESS }));
  }

  removeRolePolicyError() {
    this.store.dispatch(new QueueAlertAction({ alertText: `Policy delete failed.`, alertType: AlertType.ERROR }));
  }

  goToRoleGroupScopes(roleId: string, group: RoleGroup) {
    this.store.dispatch(new SelectGroupAction(group as any));
    this.store.dispatch(new GoAction(['/iam/roles', roleId, 'groups', group.group_id]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-details.facade.ts